import React, { useEffect } from "react";
import HomeMobileNavbar from "../components/HomeMobileNavbar";
import Navbar from "../components/Navbar";

const faqsData = [
  {
    id: "01",
    title: "Welcome to Nufab!",
    items: [
      {
        q: "Welcome to Nufab! Our Terms of Service outline the rules and guidelines for using our website and services. By using our site, you're agreeing to these terms, so please take a moment to read through them.",
      },
      {
        q: "Nufab is an independent entity and is not affiliated with, endorsed by, or sponsored by any third-party brands, trademarks, or corporations.",
      },
      {
        q: "Email: nufab.info@gmail.com",
      },
      {
        q: "Phone: +91 9244501941",
      },
      {
        q: "Contact us at Studio Address: 201, 76-77 P-Prime, Shakti Nagar, 452018, Indore",
      },
      {
        q: "Registered Address: Exora 501 Shalimar Township, AB Road, Indore.",
      },
      {
        q: "Support Hours: Monday to Saturday, 11:00 AM – 7:00 PM IST",
      },
    ],
  },
  {
    id: "02",
    title: "Using Our Services",
    items: [
      {
        q: "You must be at least 18 years old to use our services (or have parental consent).",
      },
      {
        q: "You're responsible for keeping your account info safe and up-to-date.",
      },
      {
        q: "You're responsible for keeping your account info safe and up-to-date.",
      },
    ],
  },
  {
    id: "03",
    title: "Intellectual Property",
    items: [
      {
        q: "Our site and its content are our property. You're not allowed to copy, modify, or distribute it without permission.",
      },
      {
        q: "You're responsible for the content you upload or share on our site. We Don't upload anything that's illegal, harmful, or infringes on someone else's rights.",
      },
    ],
  },
  {
    id: "04",
    title: "Orders & Payments",
    items: [
      {
        q: "When you place an order, you're agreeing to our terms and conditions.",
      },
      {
        q: "We accept various payment methods, and you'll be asked to provide payment info to complete your order.",
      },
      {
        q: "Prices are subject to change, and we'll notify you of any changes.",
      },
    ],
  },
  {
    id: "05",
    title: "Shipping & Delivery",
    items: [
      {
        q: "We ship products within India. Delivery times vary depending on your location.",
      },
      {
        q: "You're responsible for providing accurate shipping info, and Nufab won't be liable for delays or losses due to incorrect info.",
      },
      {
        q: "Please check out Shipping and Delivery Policy for more details. You can find it in the website footer.",
      },
    ],
  },
  {
    id: "06",
    title: "Returns & Refunds",
    items: [
      {
        q: "We have a separate Returns and Refunds Policy that outlines our process for handling returns and refunds. Please check our policy for details on eligibility, timelines, and procedures. You can find it in the website footer.",
      },
    ],
  },
  {
    id: "07",
    title: "Warranty & Liability",
    items: [
      {
        q: "We make no warranties about our services or products, express or implied.",
      },
      {
        q: "We're liable for any loss or inconvenience made by Nufab.",
      },
    ],
  },
  {
    id: "08",
    title: "Governing Law",
    items: [
      {
        q: "These terms are governed by Indian law, and any disputes will be resolved through arbitration in accordance with Indian Arbitration and Conciliation Act, 1996.",
      },
      {
        q: "We may update these terms from time to time, and changes will be posted on our site. By continuing to use our services, you agree to the updated terms.",
      },
    ],
  },
];

const SECTIONS_WITH_MIN_THREE_ROWS = new Set([
  "Intellectual Property",
  "Returns & Refunds",
  "Warranty & Liability",
]);

const TermsPage = () => {
  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}
    <div className="w-full max-w-full mx-auto px-4 md:px-6 py-10 md:py-20 font-[bdogrotesk] text-black">
      <p className="text-black text-lg font-medium mb-6 md:mb-0">Terms Of Service</p>
      {faqsData.map((section, sectionIdx) => (
        
        <div
          key={section.id}
          // Responsive: Stack vertically on mobile (flex-col), horizontal on large screens (lg:flex-row)
          className="flex flex-col lg:flex-row gap-6 lg:gap-10 border-b border-black pt-10 pb-4 md:pb-10 lg:pb-0"
        >
          {/* Left column (ID) */}
          <div className="text-base font-medium text-black tracking-wide w-full lg:w-20 flex-shrink-0">
            {section.id}
          </div>

          {/* Right column (Title + Items) */}
          {/* Responsive: Stack on mobile and use balanced desktop columns */}
          <div className="flex-1 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(260px,1fr)_minmax(560px,1.2fr)] lg:items-start lg:gap-10">
            
            {/* Title */}
            {/* Responsive: text-3xl on mobile, text-6xl on desktop with centered title block */}
            <h2 className="w-full max-w-[420px] text-3xl md:text-5xl lg:text-6xl font-medium break-words lg:justify-self-center">
              {section.title}
            </h2>

            {/* Items List */}
            <div
              className={`space-y-4 w-full ${SECTIONS_WITH_MIN_THREE_ROWS.has(section.title) ? "lg:min-h-[10rem]" : ""}`}
            >
              {section.items.map((item, itemIdx) => {
                const key = `${sectionIdx}-${itemIdx}`;
                const isLast = itemIdx === section.items.length - 1;

                return (
                  <div
                    key={key}
                    className={`${!isLast ? "border-b border-black" : ""} pb-4`}
                  >
                    <div className="w-full flex justify-between items-start text-left">
                      <span className="text-sm md:text-base text-black font-medium pr-0 md:pr-6 leading-relaxed">
                        {item.q}
                      </span>
                    </div>

                    {/* Accordion content placeholder (kept structure in case you enable it later) */}
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out hidden`}>
                      <div className="overflow-hidden">
                        <p className="text-sm md:text-base leading-relaxed pr-10">
                          {/* {item.a} */}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default TermsPage;